import { ValidShipOrder } from '../';

export class SplitShipOrderResponse {
  originalShipOrder: ValidShipOrder;
  newShipOrders: ValidShipOrder[] = [];

  constructor(opts: SplitShipOrderResponse) {
    this.originalShipOrder = new ValidShipOrder(opts.originalShipOrder);
    this.newShipOrders = opts.newShipOrders.map((so) => new ValidShipOrder(so));
  }
}
